import React from 'react';
import { useLocation } from 'react-router-dom';

const pageTitle: Record<string, string> = {
  dashboard:     "Dashboard",
  agents:        "AI Agents",
  campaigns:     "Campaigns",
  conversations: "Conversations",
  contacts:      "Contacts",
  templates:     "Templates",
  analytics:     "Analytics",
  settings:      "Settings",
};

export default function Header(): React.JSX.Element {
  const location = useLocation();
  const segment = location.pathname.replace(/^\//, '').split('/')[0];
  const title = pageTitle[segment] ?? "Digitix";

  return (
    <header className="px-8 py-4 border-b border-dx-border flex justify-between items-center bg-dx-surface sticky top-0 z-10">
      <div>
        <h1 className="text-[22px] font-bold text-dx-text m-0">{title}</h1>
      </div>
      <div className="flex items-center gap-4">
        <div className="relative">
          <input
            placeholder="Search..."
            className="py-2 pr-3.5 pl-9 rounded-[10px] border border-dx-border bg-dx-bg text-dx-text text-[13px] outline-none w-[220px]"
          />
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-dx-dim">🔍</span>
        </div>
        <div className="w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold text-dx-accent cursor-pointer bg-[linear-gradient(135deg,rgba(37,211,102,0.19),rgba(167,139,250,0.19))]">
          SA
        </div>
      </div>
    </header>
  );
}
